import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  Text,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';

const MessagesHelpModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Messages Help</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={4} align="stretch">
            <Text>
              The Messages page allows you to send text messages to individual members or groups.
              Here's how to use it:
            </Text>

            <Text fontWeight="bold">Sending Messages</Text>
            <UnorderedList spacing={2}>
              <ListItem>
                Choose between sending to individual members or a group using the radio buttons
              </ListItem>
              <ListItem>
                For individual recipients: Select members from the list by checking the boxes next to their names
              </ListItem>
              <ListItem>
                For group messages: Select a group from the dropdown to send to all its members
              </ListItem>
              <ListItem>
                Type your message in the text box. You can add emojis using the emoji picker button
              </ListItem>
            </UnorderedList>

            <Text fontWeight="bold">Testing Messages</Text>
            <UnorderedList spacing={2}>
              <ListItem>
                Use the "Send Test" button to send a test message to yourself before sending to others
              </ListItem>
              <ListItem>
                Make sure your phone number is added to your profile to receive test messages
              </ListItem>
            </UnorderedList>

            <Text fontWeight="bold">Important Notes</Text>
            <UnorderedList spacing={2}>
              <ListItem>
                Only members who have given consent to receive messages will be shown in the lists
              </ListItem>
              <ListItem>
                Messages are sent immediately when you click "Send Now"
              </ListItem>
              <ListItem>
                Use the search box to quickly find specific members or groups
              </ListItem>
            </UnorderedList>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default MessagesHelpModal;
